import { render, staticRenderFns } from "./listAll.vue?vue&type=template&id=65056df4&scoped=true"
import script from "./listAll.vue?vue&type=script&lang=js"
export * from "./listAll.vue?vue&type=script&lang=js"
import style0 from "./listAll.vue?vue&type=style&index=0&id=65056df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65056df4",
  null
  
)

export default component.exports